import llmsTask from './llmsTask.vue';
import Vue from 'vue';

const defaults = {
    apiUrl: "",
    llmName:""
};

function getllmsTaskInstance (apiUrl=defaults.apiUrl,llmName=defaults.llmName,onOk,onCancel, parentContext) {
        const _props =  {
            apiUrl: apiUrl,
            llmName:llmName,
            onOk:onOk
        };
        const Instance = new Vue({
            provide() {
                return {
                    parentContext: parentContext
                };
            },
            render (h) {
                return h(llmsTask, {
                    props: _props
                });
            }
        });
        const component = Instance.$mount();
        document.body.appendChild(component.$el);
        const notification = Instance.$children[0];
        return {
            destroy () {
                notification.close()
            }
        };
}


export default {
    name: 'llmsTask',
    ai (options, parentContext) {
        this.llmsTaskInstance=getllmsTaskInstance(options.apiUrl,options.llmName,options.onOk,options.onCancel,parentContext);// 传入父组件的 this
        return this.llmsTaskInstance;
    },
    close () {
        this.llmsTaskInstance.destroy()
    }
};;


// WEBPACK FOOTER //
// ./src/components/llmsTask/index.js